var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("抱歉，您访问的页面不存在")]),_c('router-link',{staticStyle:{"color":"#409EFF","text-decoration":"underline"},attrs:{"to":"/"}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }